export default class Footer extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-footer', Footer);
